/* eslint-disable */
import axios from 'axios';

/** @value { axios } registry service */
let registry;
/** @value { axios } inventory service */
let inventory;

/**
 *
 * @param {string} type accepts 'registry' or 'inventory' string
 * @param {string} token recives keycloak token
 * @returns
 */

function Api(type, token) {
  const baseUrls = {
    registry: process.env.REACT_APP_API_REGISTRY,
    inventory: process.env.REACT_APP_API_INVENTORY
  };

  const baseURL = baseUrls[type];

  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json, */*',
      Accept: 'application/json, */*',
      authorization: `Bearer ${token}`
    }
  });
}

export const request = axios.create({
  baseURL: 'https://api-sdp.gateway.linkapi.com.br/v1',
  params: {
    apiKey: '0cc751bddd0f483386191f144702f26b'
  }, 
  headers: {
    'Content-Type': 'application/json, */*',
    Accept: 'application/json, */*',
    authorization: `Bearer`
  }
});

/**
 *
 * @param {string} token recives keycloak token
 */

export const initRegistry = (token) => {
  registry = Api('registry', token);
};

/**
 *
 * @param {string} token recives keycloak token
 */

export const initInventory = (token) => {
  inventory = Api('inventory', token);
};

/**
 *
 * @returns {import('axios').AxiosStatic} registtry service
 */
export const getRegistry = () => registry;
/**
 *
 * @returns {import('axios').AxiosStatic} inventory service
 */
export const getInventory = () => inventory;
